import authLogic from "./auth";
import countryLogic from "./country";
import marketLogic from "./market";
import mappingLogic from "./mapping";

export default [...authLogic, ...countryLogic, ...marketLogic, ...mappingLogic];
